import React, { useEffect } from "react";

/**
 * In dev (yarn start), Firebase rewrite is not applied: /cgu-hertz-la-premiere
 * is handled by the React app. This component redirects to the static .html page.
 * In prod, the rewrite serves cgu-hertz-la-premiere.html directly so this component is never reached.
 */
export default function CguHertzLaPremiereRedirect() {
  useEffect(() => {
    window.location.replace("/cgu-hertz-la-premiere.html");
  }, []);
  return null;
}
